export default {
	state: {
		token: null,
		user: null,
    company_id: null,
    company_name: null,
		isAuthenticated: false
	},
	initialize() {
		this.state.token = localStorage.getItem('token');
		this.state.user = localStorage.getItem('user');
		this.state.company_id = parseInt(localStorage.getItem('company_id'));
    this.state.company_name = localStorage.getItem('company_name');
		this.state.isAuthenticated = this.isAuthenticated();
	},
	set(token, user, company_id, company_name) {
		localStorage.setItem('token', token)
		localStorage.setItem('user', user)
    localStorage.setItem('company_id', company_id)
    localStorage.setItem('company_name', company_name)
		this.initialize()
	},
	remove() {
		localStorage.removeItem('token')
		localStorage.removeItem('user')
		localStorage.removeItem('company_id')
		localStorage.removeItem('company_name')
		this.initialize()
	},
  isAuthenticated() {
    if (this.state.token != null && this.state.user != null && this.state.company_id != null && this.state.company_name != null) {
      return true
    }
    return false
  }
}